


























import { Component, Vue } from 'nuxt-property-decorator'
import { Service } from './BriefViewServices.vue'

@Component<OBrief>({})
export default class OBrief extends Vue {
  submitted = false

  model: {
    services: string[];
    showBudget: boolean;
    budget: {
      web?: { min: number; max: number; };
      mobile?: { min: number; max: number; };
      ecommerce?: { min: number; max: number; };
      branding?: { min: number; max: number; };
    };
    task: {
      text?: string;
      files?: File[]
    };
    contact: {
      name?: string;
      company?: string;
      email?: string;
      phone?: string;
      agreement: boolean;
    }
  } = {
    services: [],
    showBudget: false,
    budget: {},
    task: {
      text: '',
      files: []
    },
    contact: {
      name: '',
      company: '',
      email: '',
      phone: '',
      agreement: false
    }
  }

  get totalValue() {
    let total = 0

    let types = this.model.services
    for (const [key, value] of Object.entries(this.model.budget)) {
      if (value) {
        if (types.includes(key)) {
          total += value.max
        }
      }
    }

    return total
  }

  isContactValid = true
  contactErrors: {
    fields: string[];
    message: string;
  }[] = []

  validateContact(
    validate: boolean,
    errors: {
      fields: string[];
      message: string;
    }[]
  ) {
    this.isContactValid = validate
    this.contactErrors = errors
  }

  getTypeName(type: string) {
    switch (type) {
      case 'web': return 'Web development'
      case 'mobile': return 'Mobile development'
      case 'product-design': return 'Product design'
      case 'qa-and-testing': return 'QA & testing'
      case 'outsourcing': return 'Outsourcing'
      case 'branding': return 'Branding'
      case 'ui-ux-design': return 'UI/UX design'
      case 'seo-sem-sxo': return 'SEO, SEM, SXO'
      case 'marketing': return 'Marketing'
      case 'social-media': return 'Social media'
      default: return '???'
    }
  }

  getMinSum() {
    return Object.values(this.model.budget).map(item => item.min).reduce((prev, curr) => prev + curr)
  }

  getMaxSum() {
    return Object.values(this.model.budget).map(item => item.max).reduce((prev, curr) => prev + curr)
  }

  submit() {
    this.submitted = true

    if (!this.isContactValid) {
      if (this.contactErrors) {
        this.$toasted.show('Abyśmy mogli się z Tobą skontaktować, musisz podać dane kontaktowe i wyrazić zgodę.', { type: 'error', duration: 5000 })
      }
      return false
    }

    let types = this.model.services
    let budgets: {
      type: Service;
      min: number;
      max: number;
    }[] = []

    for (const [key, value] of Object.entries(this.model.budget)) {
      if (value) {
        if (types.includes(key)) {
          budgets.push({
            type: key as Service,
            min: value.min,
            max: value.max
          })
        }
      }
    }

    const data = {
      type: types.map(t => this.getTypeName(t)).join(', '),
      budget:
      this.model.showBudget && this.model.services && this.model.services.length
        ? (budgets && budgets.length ? 'Usługi:\n\n' : '') +
          (budgets.map(b => `- ${this.getTypeName(b.type)}: ${new Intl.NumberFormat().format(b.min)} - ${new Intl.NumberFormat().format(b.max)} ${this.$i18n.locale === 'pl' ? 'PLN' : 'USD'}`).join('\n')) +
          (budgets && budgets.length ? '\n\n\n' + `Budżet projektu: ${new Intl.NumberFormat().format(this.getMinSum())} - ${new Intl.NumberFormat().format(this.getMaxSum())} ${this.$i18n.locale === 'pl' ? 'PLN' : 'USD'}` : '')
        : '- nie określono budżetu -',
      task: this.model.task.text,

      name: this.model.contact.name,
      company: this.model.contact.company,
      email: this.model.contact.email,
      phone: this.model.contact.phone,
      consent: this.model.contact.agreement ? this.$tc('pages.brief.form.terms.text')  : '- brak zgody -'
    }

    this.$nuxt.$loading.start()
    this.$axios.post('items/quote_requests', data)
      .then(({ data: { data } }) => {
        this.$router.push(this.localePath({ name: 'brief-success' }))
        this.$ga.event({
          eventCategory: 'BriefSubmit',
          eventAction: 'Success',
          eventLabel: 'Wysłano brief',
          eventValue: this.totalValue
        })
      })
      .catch(error => {
        this.$router.push(this.localePath({ name: 'brief-error' }))
        this.$ga.event({
          eventCategory: 'BriefSubmit',
          eventAction: 'Error',
          eventLabel: 'Błąd podczas wysyłania briefu',
          eventValue: this.totalValue
        })
      })
      .finally(() => {
        this.$nuxt.$loading.finish()
      })
  }
}
